<template>
  <el-form
    :model="itemData"
    inline
    ref="ruleForm"
    label-width="130px"
    class="ruleForm circulateItem_ruleForm"
    :class="state ? '' : 'error_color'"
  >
    <el-form-item label="流通主体名称">
      <el-input
        v-model="itemData.name"
        @change="checkDataFun"
        clearable
        class="wihe"
      ></el-input>
    </el-form-item>
    <el-form-item label="流通主体地址">
      <!-- 省 -->
      <el-select
        v-model="itemData.provinceId"
        @change="
          handSelect(
            itemData.provinceId,
            'market',
            'provinceList',
            'provinceName',
            ['cityId', 'countyId']
          )
        "
        class="small_wihe"
        placeholder="省"
        @clear="
          clearDataFun([
            'cityId',
            'cityName',
            'countyId',
            'countyName',
            'provinceName',
          ])
        "
        clearable
      >
        <el-option
          v-for="({ areaName, id }, index) in provinceList"
          :key="index"
          :label="areaName"
          :value="id"
        ></el-option>
      </el-select>
      <!-- 市 -->
      <el-select
        v-model="itemData.cityId"
        @change="
          handSelect(itemData.cityId, 'area', 'market', 'cityName', [
            'countyId',
          ])
        "
        :disabled="!itemData.provinceId"
        class="small_wihe"
        placeholder="市"
        @clear="clearDataFun(['cityName', 'countyId', 'countyName'])"
        clearable
      >
        <el-option
          v-for="({ areaName, id }, index) in market"
          :key="index"
          :label="areaName"
          :value="id"
        ></el-option>
      </el-select>
      <!-- 区 -->
      <el-select
        v-model="itemData.countyId"
        @change="handSelect(itemData.countyId, '', 'area', 'countyName', [])"
        :disabled="!itemData.cityId"
        class="small_wihe"
        @clear="clearDataFun(['countyName'])"
        placeholder="区"
        clearable
      >
        <el-option
          v-for="({ areaName, id }, index) in area"
          :key="index"
          :label="areaName"
          :value="id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="联系人">
      <el-input
        v-model="itemData.contacts"
        @change="checkDataFun"
        clearable
        class="wihe"
      ></el-input>
    </el-form-item>
    <el-form-item label="联系电话" prop="contactsTel">
      <el-input
        v-model="itemData.contactsTel"
        @change="checkDataFun"
        clearable
        class="wihe"
      ></el-input>
    </el-form-item>
    <el-button
      v-if="index"
      class="delete"
      size="mini"
      icon="el-icon-delete"
      type="text"
      @click="removeData(index)"
    >
      删除
    </el-button>
  </el-form>
</template>
<script>
import { getProvinceCityArea } from "@/api/request/snkd.foundation";

export default {
  name: "circulateItem",
  props: {
    itemData: {
      type: Object,
      request: true,
    },
    index: {
      type: Number,
      request: true,
    },
    provinceList: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      //   省
      province: [],
      //   市
      market: [],
      //   区
      area: [],
      state: true,
    };
  },
  methods: {
    checkDataFun() {
      let conmpstate = null;
      let allState = false;
      const { name, contacts, contactsTel, provinceId, cityId, countyId } =
        this.itemData;
      if (name || contacts || contactsTel) {
        conmpstate = true;
      } else if (
        !name &&
        !contacts &&
        !contactsTel &&
        provinceId &&
        cityId &&
        countyId
      ) {
        conmpstate = true;
      } else {
        conmpstate = false;
      }
      this.itemData.state = conmpstate;
      if (name && contacts && contactsTel && provinceId && cityId && countyId) {
        allState = true;
      }
      this.$emit("backState", { state: conmpstate, i: this.index, allState });
    },
    clearDataFun(params) {
      params.map((item) => {
        this.itemData[item] = "";
      });
      this.checkDataFun();
    },
    removeData(i) {
      this.state = true;
      this.$emit("removeList", i);
    },
    async handSelect(val, option, selectoption, name, paremslist) {
      if (!val) return;
      this.itemData[name] = this[selectoption].filter(
        (item) => item.id == val
      )[0].areaName;
      try {
        const {
          obj: { list },
        } = await getProvinceCityArea({ parentId: val });
        this[option] = list;
      } catch (error) {
        console.log(error);
      } finally {
        if (paremslist.length) {
          this.clearDataFun(paremslist);
        }
        this.checkDataFun();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ruleForm {
  background-color: #f6f8fb;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border: 1px solid #f6f8fb;
  position: relative;
}

.circulateItem_ruleForm {
  ::v-deep .el-form-item {
    margin-top: 20px !important;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}

.ruleForm .el-form-item {
  width: 50%;
  margin-right: 0px;
  margin-top: 20px;
}

.wihe {
  width: 320px;
}

.small_wihe {
  width: 100px;
  margin-right: 10px;
}

.error_color {
  border-color: #f56c6c;
}

.delete {
  color: #f56c6c;
  position: absolute;
  right: 10px;
  top: 10px;
}

.wihe_max {
  width: 380px;
}
</style>
